import Team from "@mapmycustomers/shared/types/Team";

const mapTeamRecord = (team: Team): Pick<Team, "id" | "name"> => ({
  id: team.id,
  name: team.name,
});

export default mapTeamRecord;
